"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.array.find-index");

require("core-js/modules/es6.date.now");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");
/**
 * @ignore
 */


var SelectWidget =
/** @class */
function (_super) {
  __extends(SelectWidget, _super);

  function SelectWidget(props) {
    var _this = _super.call(this, props) || this;

    _this.isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

    _this.handleBodyClick = function (e) {
      if (!_this.containerElm || _this.isTargetInput(e.target)) {
        return;
      }

      if (e.target !== _this.containerElm && e.target.parentElement !== _this.containerElm) {
        _this.props.onEscape(false);
      }
    };

    _this.handleFocusLost = function (e) {
      if (!_this.containerElm || _this.isTargetInput(e.relatedTarget)) {
        // If you blur the SelectWidget, are you still on the InputSelect component?
        return;
      }

      if (!e.relatedTarget || e.relatedTarget && !_this.isTargetInput(e.relatedTarget)) {
        // 1) if you blur and there is no relatedTarget (e.g. mouseclick on an element that cannot be focused).
        // 2) if the next target is not within this input
        _this.props.onEscape(false);

        if (_this.props.onBlur) {
          _this.props.onBlur(_this.props.name + "Widget", e);
        }
      }
    };

    _this.onKeyDown = function (e) {
      // TODO performance
      switch (e.key) {
        case "Escape":
          // TODO typescript
          _this.props.onEscape(true);

          break;

        case "Down": // IE specific value

        case "ArrowDown":
          e.preventDefault();

          _this.setState({
            selectedIndex: _this.state.selectedIndex + 1 < _this.props.options.length ? _this.state.selectedIndex + 1 : 0,
            keyboardInteraction: true
          });

          break;

        case "Up": // IE specific value

        case "ArrowUp":
          e.preventDefault();

          _this.setState({
            selectedIndex: _this.state.selectedIndex - 1 >= 0 ? _this.state.selectedIndex - 1 : _this.props.options.length - 1,
            keyboardInteraction: true
          });

          break;

        case "Enter":
          _this.props.onChange(_this.props.options[_this.state.selectedIndex].value, _this.props.name, e);

          break;

        case "Home":
          e.preventDefault();

          _this.setState({
            selectedIndex: 0,
            keyboardInteraction: true
          });

          break;

        case "End":
          e.preventDefault();

          _this.setState({
            selectedIndex: _this.props.options.length - 1,
            keyboardInteraction: true
          });

          break;

        default:
          if (e.key.length === 1) {
            var currentTimestamp = Date.now();

            if (currentTimestamp - _this.state.lastTyped < SelectWidget.typeAheadDelayMS) {
              _this.typeAhead(_this.state.typeAhead + e.key, currentTimestamp);
            } else {
              _this.typeAhead(e.key, currentTimestamp);
            }
          }

          break;
      }
    };

    _this.typeAhead = function (typeAhead, lastTyped) {
      var lastTwo = typeAhead.substr(-2);
      var isSameCharacter = typeAhead.length < 2 || _this.state.isSameCharacter && lastTwo[0] === lastTwo[1];
      var selectedIndex = _this.state.selectedIndex;

      if (isSameCharacter) {
        var indexTail = _this.props.options.slice(selectedIndex + 1).findIndex(function (option) {
          return option.label.toLowerCase().startsWith(lastTwo[0]);
        });

        var index = indexTail >= 0 ? selectedIndex + 1 + indexTail : _this.props.options.findIndex(function (option) {
          return option.label.toLowerCase().startsWith(lastTwo[1]);
        });
        selectedIndex = index >= 0 ? index : selectedIndex;
      } else {
        var indexTail = _this.props.options.slice(selectedIndex).findIndex(function (option) {
          return option.label.toLowerCase().startsWith(typeAhead);
        });

        var index = indexTail >= 0 ? selectedIndex + indexTail : _this.props.options.findIndex(function (option) {
          return option.label.toLowerCase().startsWith(typeAhead);
        });
        selectedIndex = index >= 0 ? index : selectedIndex;
      }

      if (selectedIndex >= 0) {
        _this.setState({
          selectedIndex: selectedIndex,
          typeAhead: typeAhead,
          lastTyped: lastTyped,
          isSameCharacter: isSameCharacter,
          keyboardInteraction: true
        });
      } else {
        _this.setState({
          typeAhead: typeAhead,
          lastTyped: lastTyped,
          isSameCharacter: isSameCharacter,
          keyboardInteraction: true
        });
      }
    };

    _this.onMouseOver = function (i) {
      _this.setState({
        selectedIndex: i,
        keyboardInteraction: false
      });
    };

    _this.isTargetInput = function (t) {
      var target = t;

      while (target) {
        if (target === _this.containerElm.parentElement) {
          return true;
        }

        target = target.parentElement;
      }

      return false;
    };

    _this.handleFocusLostBlur = function (e) {
      // We need the "related" target -> this is the element which gets the focus next.
      // With IE11, the onBlur event does not support the relatedTarget (it's null in IE)
      if (!_this.isIE11) {
        _this.handleFocusLost(e);
      }
    };

    _this.handleFocusLostFocusout = function (e) {
      // We need the "related" target -> this is the element which gets the focus next.
      // With IE11, the onBlur event does not support the relatedTarget (it's null in IE)
      // Only the onfocusout event contains the relatedTarget.
      // Unfortunately, you cannot use a React onfocusout event (because it does not exist).
      if (_this.isIE11) {
        _this.handleFocusLost(e);
      }
    };

    var selectedIndex = props.options.findIndex(function (option) {
      return option.value === props.value;
    });
    _this.state = {
      selectedIndex: selectedIndex >= 0 ? selectedIndex : 0,
      typeAhead: "",
      lastTyped: Date.now(),
      isSameCharacter: true,
      keyboardInteraction: false
    };
    return _this;
  }

  SelectWidget.prototype.componentDidMount = function () {
    // laut W3C muss das Dropdown gefocused werden, wenn geöffnet
    if (this.containerElm && this.containerElm !== document.activeElement) {
      this.containerElm.focus();
    }

    document.body.addEventListener("click", this.handleBodyClick);
    this.containerElm.addEventListener("blur", this.handleFocusLostBlur);
    this.containerElm.addEventListener("focusout", this.handleFocusLostFocusout);
  };

  SelectWidget.prototype.componentWillUnmount = function () {
    document.body.removeEventListener("click", this.handleBodyClick);
    this.containerElm.removeEventListener("blur", this.handleFocusLostBlur);
    this.containerElm.removeEventListener("focusout", this.handleFocusLostFocusout);
  };

  SelectWidget.prototype.componentDidUpdate = function (_prevProps, prevState) {
    if (this.state.selectedIndex !== prevState.selectedIndex && this.selectedElm && this.state.keyboardInteraction) {
      var clientRects = this.selectedElm.getBoundingClientRect();
      var parentClientRects = this.containerElm.getBoundingClientRect();
      var offsetTop = clientRects.y - parentClientRects.y;
      var offsetBottom = clientRects.y + clientRects.height - (parentClientRects.y + parentClientRects.height);

      if (offsetTop < 0) {
        this.containerElm.scrollTop += offsetTop;
      }

      if (offsetBottom > 0) {
        this.containerElm.scrollTop += offsetBottom;
      }
    }

    this.containerElm.focus();
  };

  SelectWidget.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        options = _a.options,
        value = _a.value,
        onChange = _a.onChange,
        name = _a.name,
        idInput = _a.idInput,
        openAbove = _a.openAbove;
    var selectedIndex = this.state.selectedIndex;
    return React.createElement("div", {
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "inputselect-widget", openAbove && CSSPrefix_1.lsgPre + "inputselect-widget__openabove"]),
      onKeyDown: this.onKeyDown,
      ref: function ref(r) {
        return _this.containerElm = r;
      },
      role: "listbox",
      "aria-labelledby": idInput + "_label",
      "aria-activedescendant": idInput + "_option" + selectedIndex,
      tabIndex: -1
    }, options.map(function (option, i) {
      var Component = option.iconLinkProps && option.iconLinkProps.href && "a" || "div";
      return React.createElement(Component, __assign({
        id: idInput + "_option" + i,
        className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "inputselect-option", option.value === value && CSSPrefix_1.lsgPre + "inputselect-option__active", i === selectedIndex && CSSPrefix_1.lsgPre + "inputselect-option__selected", option.disabled && CSSPrefix_1.lsgPre + "inputselect-option__disabled"])
      }, option.iconLinkProps ? option.iconLinkProps : {}, {
        onClick: function onClick(e) {
          onChange(option.value, name, e);

          if (option.iconLinkProps && option.iconLinkProps.onClick) {
            option.iconLinkProps.onClick(e);
          }
        },
        key: option.value,
        ref: function ref(r) {
          if (i === selectedIndex) {
            _this.selectedElm = r;
          }
        },
        onMouseOver: function onMouseOver() {
          return _this.onMouseOver(i);
        },
        "aria-selected": i === selectedIndex,
        role: "option"
      }), option.label);
    }));
  };

  SelectWidget.typeAheadDelayMS = 1000;
  return SelectWidget;
}(React.Component);

exports.SelectWidget = SelectWidget;